import {
  COMPANION_PRESET_CONFIG,
  COMPANION_PRESET_VALUES,
  DEFAULT_COMPANION_PRESET,
  type CompanionPreset,
  type CompanionPresetConfig,
} from '@/config/companionPresets';

export const COMPANION_PRESET_ATTR = 'data-companion-preset';

export function isCompanionPreset(value: string | null | undefined): value is CompanionPreset {
  return COMPANION_PRESET_VALUES.includes(value as CompanionPreset);
}

/** Remonte depuis une plateforme DOM jusqu'au preset du bloc parent. */
export function resolveCompanionPreset(
  element: Element | null | undefined,
): CompanionPreset {
  if (!element) return DEFAULT_COMPANION_PRESET;
  const host = element.closest(`[${COMPANION_PRESET_ATTR}]`);
  const raw = host?.getAttribute(COMPANION_PRESET_ATTR);
  return isCompanionPreset(raw) ? raw : DEFAULT_COMPANION_PRESET;
}

export function resolveCompanionPresetConfig(
  element: Element | null | undefined,
): CompanionPresetConfig {
  return COMPANION_PRESET_CONFIG[resolveCompanionPreset(element)];
}

/** Attributs à poser sur le wrapper racine d'un bloc plateforme. */
export function companionPresetAttrs(
  preset: CompanionPreset | null | undefined,
  fallback: CompanionPreset = DEFAULT_COMPANION_PRESET,
): { [COMPANION_PRESET_ATTR]: CompanionPreset } {
  return {
    [COMPANION_PRESET_ATTR]: preset ?? fallback,
  };
}
